module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-new-customer"
  }, [(_vm.removable) ? _c('div', {
    staticClass: "close-button",
    on: {
      "click": _vm.on_remove
    }
  }, [_c('i', {
    staticClass: "icon close"
  })]) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form._id || _vm.form.from_card_reader),
      expression: "form._id || form.from_card_reader"
    }],
    staticClass: "selected-customer"
  }, [_c('i', {
    staticClass: "mi"
  }, [_vm._v("person")]), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.form.name)), (_vm.cancelable) ? _c('i', {
    staticClass: "icon delete",
    on: {
      "click": _vm.cancel_select
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "sub"
  }, [_vm._v(_vm._s(_vm.form.phone1 || '-'))])]), _c('el-form', {
    ref: "form",
    staticClass: "ui form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "four fields"
  }, [_c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "name"
    }
  }, [_c('label', [_vm._v("姓名")]), _c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.query_search_by("name"),
      "custom-item": "customer-item",
      "disabled": _vm.disabled
    },
    on: {
      "select": _vm.handle_select
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "phone1"
    }
  }, [_c('label', [_vm._v("手机")]), _c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.query_search_by("phone1"),
      "custom-item": "customer-item",
      "disabled": _vm.disabled_info
    },
    on: {
      "select": _vm.handle_select
    },
    model: {
      value: (_vm.form.phone1),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone1", $$v)
      },
      expression: "form.phone1"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field",
    attrs: {
      "prop": "work"
    }
  }, [_c('label', [_vm._v("工作单位")]), _c('el-input', {
    attrs: {
      "type": "text",
      "disabled": _vm.disabled_info
    },
    model: {
      value: (_vm.form.work),
      callback: function($$v) {
        _vm.$set(_vm.form, "work", $$v)
      },
      expression: "form.work"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field",
    attrs: {
      "prop": "gender"
    }
  }, [_c('label', [_vm._v("性别")]), _c('el-select', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.gender),
      callback: function($$v) {
        _vm.$set(_vm.form, "gender", $$v)
      },
      expression: "form.gender"
    }
  }, [_c('el-option', {
    key: 0,
    attrs: {
      "label": " ",
      "value": 0
    }
  }), _c('el-option', {
    key: 1,
    attrs: {
      "label": "男",
      "value": 1
    }
  }), _c('el-option', {
    key: 2,
    attrs: {
      "label": "女",
      "value": 2
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "five fields"
  }, [_c('el-form-item', {
    staticClass: "ui field required",
    attrs: {
      "prop": "idcard"
    }
  }, [_c('label', [_vm._v("身份证")]), _c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.query_search_by("idcard"),
      "custom-item": "customer-item",
      "disabled": _vm.disabled
    },
    on: {
      "select": _vm.handle_select
    },
    model: {
      value: (_vm.form.idcard),
      callback: function($$v) {
        _vm.$set(_vm.form, "idcard", $$v)
      },
      expression: "form.idcard"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field",
    attrs: {
      "prop": "address"
    }
  }, [_c('label', [_vm._v("身份证地址")]), _c('el-input', {
    attrs: {
      "type": "text",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field",
    attrs: {
      "prop": "contact"
    }
  }, [_c('label', [_vm._v("紧急联络人")]), _c('el-input', {
    attrs: {
      "type": "text",
      "disabled": _vm.disabled_info
    },
    model: {
      value: (_vm.form.contact),
      callback: function($$v) {
        _vm.$set(_vm.form, "contact", $$v)
      },
      expression: "form.contact"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field",
    attrs: {
      "prop": "note"
    }
  }, [_c('label', [_vm._v("备注")]), _c('el-input', {
    attrs: {
      "type": "text",
      "disabled": _vm.disabled_info
    },
    model: {
      value: (_vm.form.note),
      callback: function($$v) {
        _vm.$set(_vm.form, "note", $$v)
      },
      expression: "form.note"
    }
  })], 1), _c('el-form-item', {
    staticClass: "ui field",
    attrs: {
      "prop": "population_recorded"
    }
  }, [_c('label', [_vm._v("其他")]), _c('br'), (!_vm.disabled && _vm.$native.supported && !_vm.form.from_card_reader) ? [_c('div', {
    staticClass: "ui button teal",
    on: {
      "click": function($event) {
        _vm.reader_start()
      }
    }
  }, [_vm._v("读卡")]), _c('span', {
    staticStyle: {
      "margin-right": "10px"
    }
  })] : _vm._e(), _c('el-checkbox', {
    attrs: {
      "label": "流动人口信息录入",
      "disabled": _vm.disabled_info
    },
    model: {
      value: (_vm.form.population_recorded),
      callback: function($$v) {
        _vm.$set(_vm.form, "population_recorded", $$v)
      },
      expression: "form.population_recorded"
    }
  })], 2)], 1)]), (_vm.$native.supported) ? _c('el-dialog', {
    attrs: {
      "title": "读取中",
      "size": "tiny",
      "visible": _vm.reader_dialog,
      "before-close": function () { return false; }
    },
    on: {
      "update:visible": function($event) {
        _vm.reader_dialog = $event
      }
    }
  }, [_c('span', [_vm._v("请将身份证放置于读卡机上")]), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.reader_dialog = false
      }
    }
  }, [_vm._v("取消")])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e266b9ee","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/forms/FormNewCustomer.vue
// module id = 366
// module chunks = 0